import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const LiveTabsNav = ({ tabs, activeTabId, onTabClick }) => {
    if (!Array.isArray(tabs)) return null;

    return (
        <div className="live-tabs">
            <div className="live-tabs__nav">
                {
                    tabs.map((tab) => {
                        const stateCss = classNames({
                            'is-active': tab.id === activeTabId
                        });

                        return (
                            <button
                                key={tab.id}
                                className={`live-tabs__link ${stateCss}`}
                                type="button"
                                onClick={() => onTabClick(tab.id)}
                            >{tab.text}</button>
                        );
                    })
                }
            </div>
        </div>
    );
};

LiveTabsNav.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        text: PropTypes.string,
    })),
    activeTabId: PropTypes.string,
    onTabClick: PropTypes.func.isRequired
};

export default LiveTabsNav;
